module.exports = __webpack_public_path__ + "img/breast_cancer_subtype.35c0770f.jpg";